import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ServiceCategory from './ServiceCategory'
import ServiceList from './ServiceList'
import ServiceDetail from './ServiceDetail'
import ServicePortfolio from './ServicePortfolio'
import PurchaseService from './PurchaseService'

const Service = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<ServiceCategory />} />
                <Route path="/servicelist/:id" element={<ServiceList />} />
                <Route path="/serviceportfolio/:userid/:marketid" element={<ServicePortfolio />} />
                <Route path="/purchase_service/:userid/:marketid" element={<PurchaseService />} />
                <Route path="/service_detail/:id" element={<ServiceDetail />} />
            </Routes>
        </div>
    )
}

export default Service